// The one-step profile form of core.md §4.3 — its fields, its rules, its states.
export const onboarding = {
  // ── onboarding — core.md §4.3 ────────────────────────────────────────
  'onboarding.title': 'Welcome — tell us who you are',
  'onboarding.sub': 'One short form. You can change any of it later in your profile.',
  'onboarding.fields.fullName': 'Full name',
  'onboarding.fields.studentNumber': 'Student number',
  'onboarding.fields.studentNumberHelper': 'Your university’s student number — not a medical council number. It is not verified.',
  'onboarding.fields.university': 'University',
  'onboarding.fields.universityHelper': 'Pick from the list or type your own.',
  'onboarding.fields.level': 'Level',
  'onboarding.fields.field': 'Specialty',
  'onboarding.fields.fieldHelper': 'The residency programme, e.g. internal medicine.',
  'onboarding.fields.entryYear': 'Entry year (Jalali)',
  'onboarding.fields.bio': 'Short bio',
  'onboarding.fields.phone': 'Mobile number',
  'onboarding.fields.phoneHelper': 'From your sign-in account; changed there, not here.',
  'onboarding.level.student': 'Medical student',
  'onboarding.level.intern': 'Intern',
  'onboarding.level.resident': 'Resident',
  'onboarding.submit': 'Start',
  'onboarding.saving': 'Saving your profile…',
  'onboarding.done': 'All set — opening your patients…',
  'onboarding.validation.fullName': 'Enter your name (2–120 characters).',
  'onboarding.validation.studentNumber': 'Enter 4–20 letters, digits or dashes.',
  'onboarding.validation.university': 'Enter your university (2–120 characters).',
  'onboarding.validation.level': 'Choose your level.',
  'onboarding.validation.field': 'At most 80 characters.',
  'onboarding.validation.entryYear': 'A Jalali year between 1370 and 1420.',
  'onboarding.validation.bio': 'At most 500 characters.',
  'onboarding.error.unavailable': 'Could not save right now. Your answers are kept — try again.',
  // A FAILED status query is rendered by App.jsx's boot gate (`auth.bootFailed.*`),
  // never by the onboarding screen: the form is shown because the status said
  // `isOnboarded: false`, and for no other reason (core.md §4.3).
};

export default onboarding;
